import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="carousel"
export default class extends Controller {

  static values = { index: Number, revert: Boolean, play: Boolean }
  static targets = ['item']

  connect() {
    if (this.playValue) {
      this.index = -1;
      this.direction = true;
      this.items = this.element.children.length;
      this.playWithTimeout()
    }

    if (this.indexValue) {
      setTimeout(() => {
        this.scrollTo(this.indexValue);

        if (this.revertValue) {
          setTimeout(() => {
            this.scrollTo(0, true);
          }, 1000);
        }
      }, 10);
    }
  }

  play() {
    if (this.direction) this.index++;
    else this.index--;

    if (this.index == 0) this.direction = true;
    else if (this.index == this.items) this.direction = false;

    this.scrollTo(this.index, true)

    this.playWithTimeout();
  }

  playWithTimeout() {
    setTimeout(this.play.bind(this), 1000)
  }

  scrollTo(x, animation = false) {
    let left = (this.element.clientWidth * 0.8) * (x - 1)

    if (animation)
      this.element.scrollTo({ left: left, behavior: 'smooth' });
    else
      this.element.scrollLeft = left;
  }
}
